export function getAuthPageContentPaddingTop({
    isMobile,
    isAuthenticated,
    pathName,
    announcementToolbarHeight,
}) {
    const basePadding = isMobile ? 30 : 18;
    const needsAnnouncementOffset = pathName === '/login'
        || pathName === '/signup'
        || pathName === '/terms'
        || pathName.startsWith('/terms/');
    const measuredBannerHeight = Number(announcementToolbarHeight);
    const bannerOffset = !isAuthenticated && needsAnnouncementOffset && Number.isFinite(measuredBannerHeight)
        ? Math.max(0, measuredBannerHeight)
        : 0;

    return basePadding + bannerOffset;
}
